<template>
  <div id="app" v-cloak>
    <router-view />
  </div>
</template>

<script>
let webInfoSock = "";
import { getToken, removeToken, setToken } from "@/utils/auth";
import { toJump } from "@/utils/jump.js";
export default {
  name: "App",
  created() {
    const searchParams = new URLSearchParams(location.search);
    const lartaiToken = searchParams.get('lartaiToken');
    if (lartaiToken) {
      if (getToken()) {
        removeToken()
      }
      setToken(lartaiToken)
      location.href = location.origin + location.pathname
    }
  },
  mounted() {
    toJump();
    console.log(location)
  },
  methods: {
    trump() {
      let is_mobi =
        navigator.userAgent
          .toLowerCase()
          .match(
            /(ipod|iphone|android|coolpad|mmp|smartphone|midp|wap|xoom|symbian|j2me|blackberry|wince)/i
          ) != null;
      if (is_mobi) {
        let host = location.host;
        let protocol = location.protocol;
        let url = `${protocol}//${host}/m/#/`;
        // let url = `http://192.168.2.135:8081/m/#/?token=${getToken()}`;
        location.href = url;
      }
    },
  },
  computed: {},
};
</script>

<style>
@import url("./assets/style/iconfont.css");

#app {
  min-width: 1300px;
}

[v-cloak] {
  display: none;
}

.SCORETAG {
  display: inline-block;
  width: 36px;
  height: 25px;
  border: 1px solid rgba(247, 137, 137, 1);
  color: rgba(247, 137, 137, 1);
  border-radius: 4px;
  font-size: 12px;
  line-height: 25px;
  text-align: center;
}

.SCORETAG:hover {
  background: rgba(247, 137, 137, 1);
  color: #fff;
}

.SCORETAGRES {
  font-weight: 700;
  font-size: 16px;
  /* text-decoration: underline; */
  color: #ff9900;
  /* position: absolute;
    right: 35px; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue